import { __assign, __generator } from "tslib";
import { getDeviationUrl } from '../../DeviationViews/_helpers';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { createCommission, changeCommissionStatus, changeCommissionStatusSuccess, updateCommission, toggleCommissionStatus, } from './actionCreators';
import { request } from '../../xhr';
import { call, all, put, select, takeEvery, takeLatest, } from 'redux-saga/effects';
import { normalize } from '../normalizr';
import { putEntities } from '../entities/actions';
import { deviationSchema } from '../normalizr/schemas/deviation';
import { CommissionStatusCodeMap, CommissionStatusType, } from '../../types/commissions';
import { getIsActive, getIsDeleted } from './selectors';
import { convertToServerXhrPayload, getEmptyServerXhrPayload, } from '../../DaEditorWrapper/utils';
import { logBiEvent } from '../../biLogger/redux/saga';
import { ResourceType } from '../../types/resource';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { getCurrentUser } from '../../publicSession/selectors';
function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        return {
            success: true,
        };
    }
}
function doPapiRequest(endpoint, data) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: endpoint,
                    data: data,
                }, fakeResponse)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
function createCommissionSaga(action) {
    var _a, title, points_cost, editorRawState, editorContent, coverImageDeviationId, features, editorPayload, params, response, currentUser;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, title = _a.title, points_cost = _a.pointsCost, editorRawState = _a.editorRawState, editorContent = _a.editorContent, coverImageDeviationId = _a.coverImageDeviationId, features = _a.features;
                editorPayload = editorRawState && editorContent && features
                    ? convertToServerXhrPayload(editorRawState, editorContent, features)
                    : getEmptyServerXhrPayload();
                params = __assign({ title: title, points_cost: points_cost, cover_image_deviation_id: coverImageDeviationId }, editorPayload);
                return [4 /*yield*/, call(doPapiRequest, '/commission/create', params)];
            case 1:
                response = _b.sent();
                if (!(response && response.deviation)) return [3 /*break*/, 4];
                return [4 /*yield*/, call(logBiEvent, PureBiData({
                        evid: 11,
                        group_exclusive: false,
                        typeid: ResourceType.COMMISSION,
                        itemid: response.deviation.deviationId,
                    }))];
            case 2:
                _b.sent();
                return [4 /*yield*/, select(getCurrentUser)];
            case 3:
                currentUser = _b.sent();
                window.location.href = "".concat(Url.userShopPath(currentUser.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS), "?commission-publish-success=1");
                return [3 /*break*/, 7];
            case 4:
                if (!(response && response.errorCode === 302)) return [3 /*break*/, 5];
                window.location.replace(response.errorDetails.redirectUrl);
                return [3 /*break*/, 7];
            case 5:
                if (!(response &&
                    response.error === 'invalid_request' &&
                    response.errorDetails &&
                    response.errorDetails.Form)) return [3 /*break*/, 7];
                return [4 /*yield*/, call(alert, "Creation of your new commission failed: ".concat(response.errorDetails.Form))];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}
export function changeCommissionStatusSaga(action) {
    var _a, deviation, status, response, updatedDeviation, entities;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, deviation = _a.deviation, status = _a.status;
                return [4 /*yield*/, call(doPapiRequest, '/commission/change_status', {
                        commissionid: deviation.deviationId,
                        status: status,
                    })];
            case 1:
                response = _b.sent();
                if (!(response && response.success)) return [3 /*break*/, 4];
                updatedDeviation = __assign({}, deviation);
                updatedDeviation.commission.status =
                    CommissionStatusCodeMap[response.data.status];
                entities = normalize(updatedDeviation, deviationSchema).entities;
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 2:
                _b.sent();
                return [4 /*yield*/, put(changeCommissionStatusSuccess(updatedDeviation))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
export function toggleCommissionStatusSaga(action) {
    var deviation, isDeleted, isActive, status;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                deviation = action.payload;
                return [4 /*yield*/, select(getIsDeleted, deviation.deviationId)];
            case 1:
                isDeleted = _a.sent();
                if (isDeleted) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getIsActive, deviation.deviationId)];
            case 2:
                isActive = _a.sent();
                status = isActive
                    ? CommissionStatusType.DISABLED
                    : CommissionStatusType.ACTIVE;
                return [4 /*yield*/, put(changeCommissionStatus({ deviation: deviation, status: status }))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export function updateCommissionSaga(action) {
    var _a, title, points_cost, coverImageDeviationId, editorRawState, editorContent, features, commissionid, editorPayload, params, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, title = _a.title, points_cost = _a.pointsCost, coverImageDeviationId = _a.coverImageDeviationId, editorRawState = _a.editorRawState, editorContent = _a.editorContent, features = _a.features, commissionid = _a.commissionid;
                editorPayload = editorRawState && editorContent && features
                    ? convertToServerXhrPayload(editorRawState, editorContent, features)
                    : getEmptyServerXhrPayload();
                params = __assign({ commissionid: commissionid, title: title, cover_image_deviation_id: coverImageDeviationId, points_cost: points_cost }, editorPayload);
                return [4 /*yield*/, call(doPapiRequest, '/commission/update', params)];
            case 1:
                response = _b.sent();
                if (response && response.deviation) {
                    window.location.assign(getDeviationUrl(response.deviation));
                }
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(changeCommissionStatus, changeCommissionStatusSaga),
                    takeLatest(toggleCommissionStatus, toggleCommissionStatusSaga),
                    takeEvery(updateCommission, updateCommissionSaga),
                    takeLatest(createCommission, createCommissionSaga),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map